export default __webpack_public_path__ + "static/media/pf.fbd548e6.svg";